"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MembershipEmailDefaultOptions = exports.EMAIL_TEMPLATE_TYPES = exports.MembershipEmailFields = exports.MembershipEmailSubcategories = exports.MembershipEmailTypes = void 0;
var MembershipEmailTypes = {
  MEMBERSHIP_REGISTRATION_EMAIL: 'MEMBERSHIP_REGISTRATION_EMAIL',
  MEMBERSHIP_PASSWORD_SAVED_EMAIL: 'MEMBERSHIP_PASSWORD_SAVED_EMAIL',
  MEMBERSHIP_PASSWORD_RESET_EMAIL: 'MEMBERSHIP_PASSWORD_RESET_EMAIL'
};
exports.MembershipEmailTypes = MembershipEmailTypes;
var MembershipEmailSubcategories = {
  membership_registration: 'membership_registration',
  membership_password_saved: 'membership_password_saved',
  membership_password_reset: 'membership_password_reset'
};
exports.MembershipEmailSubcategories = MembershipEmailSubcategories;
var MembershipEmailFields = {
  id: 'id',
  name: 'name',
  subcategory: 'subcategory',
  emailTemplateMode: 'emailTemplateMode'
};
exports.MembershipEmailFields = MembershipEmailFields;
var EMAIL_TEMPLATE_TYPES = {
  DRAG_AND_DROP: 'DRAG_AND_DROP',
  DESIGN_MANAGER: 'DESIGN_MANAGER'
};
exports.EMAIL_TEMPLATE_TYPES = EMAIL_TEMPLATE_TYPES;
var MembershipEmailDefaultOptions = {
  offset: 0,
  order: '-updated',
  limit: 300,
  archived: false,
  subcategory__in: [MembershipEmailSubcategories.membership_registration, MembershipEmailSubcategories.membership_password_saved, MembershipEmailSubcategories.membership_password_reset],
  property: [MembershipEmailFields.id, MembershipEmailFields.name, MembershipEmailFields.subcategory, MembershipEmailFields.emailTemplateMode]
};
exports.MembershipEmailDefaultOptions = MembershipEmailDefaultOptions;